angular
	.module 'App.Directive.EpicConfiguration'
	.directive 'epicConfigurationMenu',
		->
			restrict: 'E'
			scope:
				selectedItem: '='
				configurationsTree: '='
				oneAtATime: '@'
			controller: 'EpicConfigurationMenuController'
			controllerAs: 'epicMenu'
			bindToController: true
			templateUrl: "@directive/epic-configuration/epic-configuration.menu.view.html"

class EpicConfigurationMenuController extends AbstractController
	@register angular.module 'App.Directive.EpicConfiguration'
	@inject 'MessageTerminal'

	initialize: ->
		@oneAtATime ?= true

		if @configurationsTree.length > 0
			@selectItem @configurationsTree[0]['items'][0]

	selectItem: (item) ->
		@selectedItem = item

		@MessageTerminal.publish 'config-item-selected', item
